import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromRootStore from '@apps/root/store';
import { ColorsService } from '@common/services';
import { StaticFilterTag, Tag } from '@apps/cmdb/models';
import { IAuroraState } from '@apps/aurora.state';
@Component({
    selector: 'aa-chips-tag-item',
    templateUrl: './chips-tag-item.component.html',
    styleUrls: [
        './chips-tag-item.component.scss'
    ],
    standalone: false
})
export class ChipsTagItemComponent
{
    @Input() tag: Tag;
    @Output() public detachTagEvent: EventEmitter<string> = new EventEmitter();

    constructor (
        private store: Store<IAuroraState>
    )
    {

    }

    onCancelClick (tagId: string): void
    {
        this.detachTagEvent.emit(tagId);
    }

    getCheckColor (color: string): string
    {
        return ColorsService.getContrastColor(color, '#ffffff', '#ff0000');
    }

    onTagClick (): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagSelect({ filterTag: StaticFilterTag.mapperFromTag(this.tag) }));
    }
}
